<template>
  <div class="mobile-wrapper">
    <div :class="showNewUi ? 'new-fixed-banner' : 'fixed-banner'">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <span class="material-icons md-36" @click="goBack"
              >keyboard_arrow_left</span
            >
            <span class="title-text" @click="goBack">Loyalty</span>
          </div>
        </div>
      </div>
    </div>
    <div
      :style="styles.pageColor"
      class="vform position-relative"
      style="margin-top: -5vh"
    >
      <div class="justify-content-center">
        <div class="col-12 py-4">
          <div
            class="justify-content-center"
            :class="showNewUi ? 'mt-5' : 'vertical-center '"
          >
            <div>
              <div class="container">
                <div class="text-center">
                  <div
                    v-if="showNewUi"
                    style="color: #202020; margin-top: 11vh; font-size: 14px"
                  >
                    {{ $t("message.loyaltyPts") }}
                  </div>
                  <div v-else>{{ $t("message.loyaltyStamps") }}</div>
                  <div v-if="dbuser && showNewUi">
                    <p style="font-size: 51px; color: #66ab2f">
                      {{
                        parseInt(dbuser.RewardPoints ? dbuser.RewardPoints : 0)
                          | formatNumber
                      }}
                    </p>
                  </div>

                  <div v-if="dbuser && !showNewUi">
                    {{
                      parseInt(dbuser.RewardPoints ? dbuser.RewardPoints : 0)
                        | formatNumber
                    }}
                  </div>
                </div>

                <div class="col-12 text-center" v-if="loyaltyQr">
                  <img :src="this.loyaltyQr" style="height: 35vh" alt="" />
                </div>

                <hr v-if="!showNewUi" />

                <div class="row" :class="showNewUi && 'mt-5'">
                  <div class="col-6 text-success text-center">
                    <div v-if="showNewUi" class="d-flex ml-3">
                      <img
                        src="../../assets/newUi/icons/arrow-up.png"
                        class="loyalty-icon"
                      />
                      <span> {{ $t("message.ptsEarn") }}</span>
                    </div>
                    <div v-else>{{ $t("message.ptsEarned") }}</div>
                    <div
                      v-if="dbuser"
                      :class="showNewUi && 'new-text-black font-31 '"
                    >
                      +
                      {{
                        parseInt(
                          dbuser.EarnedRewardPoints
                            ? dbuser.EarnedRewardPoints
                            : 0
                        ) | formatNumber
                      }}
                    </div>
                  </div>
                  <div class="col-6 text-red text-center">
                    <div v-if="showNewUi" class="d-flex ml-4">
                      <img
                        src="../../assets/newUi/icons/arrow-down.png"
                        class="loyalty-icon"
                      />
                      <span> {{ $t("message.ptsSpend") }}</span>
                    </div>
                    <div v-else>{{ $t("message.ptsSpent") }}</div>
                    <div
                      v-if="dbuser"
                      :class="showNewUi && 'new-text-black font-31 '"
                    >
                      -
                      {{
                        parseInt(
                          dbuser.SpentRewardPoints
                            ? dbuser.SpentRewardPoints
                            : 0
                        ) | formatNumber
                      }}
                    </div>
                  </div>
                </div>
                <hr v-if="!showNewUi" />
              </div>
              <div
                v-if="getFirstValidRedemptionRule"
                class="container mb-4 mt-4 justify-content-center"
              >
                <div class="row justify-content-center mb-4">
                  {{ getLoyalityMessage }}
                </div>
                <template v-if="showStampCircle">
                  <div width="300" class="row justify-content-center">
                    <canvas id="circleContainer"></canvas>
                    <div :style="shapeStyles()" class="inner-shape">
                      <i class="fa fa-heart"></i>
                    </div>
                  </div>
                  <div
                    class="row justify-content-center mb-0"
                    style="m-0 w-100 text-center"
                  >
                    {{
                      dbuser.RewardPoints
                        ? dbuser.RewardPoints >
                          getFirstValidRedemptionRule.Point
                          ? getFirstValidRedemptionRule.Point
                          : dbuser.RewardPoints
                        : 0
                    }}/{{ getFirstValidRedemptionRule.Point }}
                  </div>
                </template>
              </div>
              <div
                class="row align-items-center justify-content-center mt-5 text-center"
              >
                <div class="col-12">
                  <AppleWallet
                    :user-id="userId"
                    v-if="isIos"
                    :store-id="storeId"
                    style="margin: 10px auto; width: 170px"
                  />
                  <GooglWallet
                    @update-status="(u) => updateStatus(u)"
                    style="margin: 10px auto; width: 307px"
                    v-if="!isIos"
                    :user-id="userId"
                    :store-id="storeId"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <progressindicator v-if="showProgress" style="opacity: 0.4">
    </progressindicator>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/Loyalty.js";
import common from "../../sharedscripts/Common/commonMobile.js";
import { interpolate } from "../../api/helpers/stringHelper.js";
import GooglWallet from "./partials/googleWallet.vue";
import AppleWallet from "./partials/appleWallet.vue";
import progressindicator from "../progressindicator";
import QRCode from "qrcode";

export default {
  components: {
    GooglWallet,
    AppleWallet,
    progressindicator,
  },
  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev",
        },
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      loyaltyQr: null,
      showProgress: false,
    };
  },
  computed: {
    ...mapGetters([
      "currentstore",
      "mobileStyles",
      "getFirstValidRedemptionRule",
      "styles",
      "viewConfig",
    ]),
    ...shared.computed,
    getLoyalityMessage() {
      return interpolate(
        this.$t("message.collectGetFree"),
        this.getFirstValidRedemptionRule.Point,
        this.getFirstValidRedemptionRule.Name
      );
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
  },
  async mounted() {
    if (this.showStampCircle) {
      this.drawCircleMobile(this.mobileStyles.alertInfoBackGround.background);
    }
    try {
      const customerMemberCode = this.dbuser
        ? `@${this.dbuser.CustomerMemberCode}`
        : "";
      this.loyaltyQr = await QRCode.toDataURL(customerMemberCode);
    } catch (e) {
      console.error({ e });
    }
    this.updateUserPoints();
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    },
    viewConfig(newValue) {
      if (newValue) {
        this.drawCircleMobile(this.mobileStyles.alertInfoBackGround.background);
      }
    },
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  methods: {
    ...common.methods,
    ...shared.methods,
  },
};
</script>
